import { notifyError, notifySuccess } from "@/utils/NotificationFunctions";
import axios from "axios";
import { celebApi } from "./api";

export async function uploadProfilePicture(imageFile: any, userToken: string) {
  const httpOptions = {
    headers: {
      Authorization: userToken,
    },
  };
  return axios
    .post(`${celebApi}/user/uploadAvatar`, imageFile, httpOptions)
    .then((res) => {
      notifySuccess("Profile picture updated successfully!");
      return res;
    })
    .catch((error) => {
      notifyError(
        "There was an error updating your profile picture, please try again"
      );
      return error;
    });
}

export async function updateProfileInfo(formData: any, userToken: string) {
  const httpOptions = {
    headers: {
      Authorization: userToken,
    },
  };
  return axios
    .post(`${celebApi}/user/editProfile`, formData, httpOptions)
    .then((res) => {
      notifySuccess("Profile info updated successfully!");
      return res;
    })
    .catch((error) => {
      notifyError(error.response.data.message);
      return error.response;
    });
}

export async function updateUserRecommendation(
  formData: any,
  userToken: string
) {
  const httpOptions = {
    headers: {
      Authorization: userToken,
    },
  };
  return axios
    .post(`${celebApi}/user/updateUserRecommendation`, formData, httpOptions)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      return error.response;
    });
}
